import React from 'react';
import { layout, space, color, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import styled, { keyframes } from 'styled-components';
import Loader from 'theme/icons/loader';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Button = styled.button`
  height: 56px;
  min-width: 140px;
  background: transparent;
  outline: 0;

  & > span {
    background: ${({ isFocused }) =>
      isFocused ? themeGet('colors.primary_600') : themeGet('colors.primary_400')};
    border-radius: 12px;

    padding: 0 ${themeGet('space.s')}px;

    width: 100%;
    height: 100%;

    ${color}
    ${typography}

    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background: ${themeGet('colors.primary_500')};
    }

    &:focus {
      background: ${themeGet('colors.primary_600')};
    }
  }

  &:focus {
    background: transparent;
  }

  &:disabled {
    opacity: 0.5;
  }

  ${space}
  ${layout}
`;

const WrapLoader = styled.div`
  margin-left: ${themeGet('space.xs')}px;
  width: 18px;
  height: 18px;
  animation: ${rotate} 2s linear infinite;
`;

function Btn({ style, label, type, onClick, disabled, title, isWaiting }) {
  return (
    <Button
      title={title || label}
      fontSize="h4"
      lineHeight="h4"
      fontWeight="bold"
      color="white"
      px="l"
      {...style}
      type={type}
      disabled={disabled || isWaiting}
      onClick={onClick}
    >
      <span>
        {label}
        {isWaiting && (
          <WrapLoader>
            <Loader width={18} />
          </WrapLoader>
        )}
      </span>
    </Button>
  );
}

export default Btn;
